import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const StyledProfessionalVoiceCloneUpload = styled('div')`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  flex: 1;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  height: ${(props) => (props?.height ? `${props?.height}px` : '100vh')};
  background-color: ${COLOR.white};
  overflow-y: hidden;
`;

const Wrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: calc(100vh - 72px);
  flex: 1;
  overflow-y: auto;
  position: relative;
`;
const WrapperContent = styled('div')`
  width: 100%;
  align-self: center;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-width: 1280px;
  height: 100%;
  flex: 1;
  position: relative;
`;

const StyledDenoiseDialog = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ToggleRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

const ToggleLabel = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

const InfoBox = styled('div')`
  display: flex;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  background-color: ${COLOR.infoNoiseReduction};
  align-items: flex-start;

  .info-icon {
    width: 20px;
    height: 20px;
    color: ${COLOR.blueV2};
  }
`;

export {
  StyledProfessionalVoiceCloneUpload,
  Wrapper,
  WrapperContent,
  StyledDenoiseDialog,
  ToggleRow,
  ToggleLabel,
  InfoBox,
};
